import { useState } from "react";
import React from "react";
import { warningAlert } from "@hooks/HelperHook";
import { resolveImageUrl } from "@helpers/image.helper";

type Props = {
    url: string,
    onChange: (file: File) => void
}

function ThumbnailPicker({ onChange, url }: Props) {
    const [selectedFile, setSelectedFile] = useState<string | undefined>(undefined);

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if ((event.target.files?.length || 0) > 0) {
            const file = event.target.files![0];
            const size = file.size / 1024 / 1024;

            if (size < 5) {
                setSelectedFile(URL.createObjectURL(file));
                if (onChange) onChange(file)
            } else {
                warningAlert("File must be under 5Mb")
            }
        }
    };

    return <>
        <figure className="relative inline-block">
            <img
                width={"150rem"}
                src={resolveImageUrl(!selectedFile ? url : selectedFile)}
                alt="collection avatar"
                className="rounded-xl border-[5px] border-gray-400"
            />
            <div
                className="group absolute -right-3 -bottom-2 h-8 w-8 overflow-hidden rounded-full border border-jacarta-100 bg-white text-center hover:border-transparent hover:bg-jacarta-500"
            >
                <input onChange={handleFileChange} type="file" accept="image/*" className="absolute top-0 left-0 w-full cursor-pointer opacity-0" />
                <div className="flex h-full items-center justify-center">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width="24"
                        height="24"
                        className="h-4 w-4 fill-jacarta-400 group-hover:fill-white"
                    >
                        <path fill="none" d="M0 0h24v24H0z" />
                        <path
                            d="M15.728 9.686l-1.414-1.414L5 17.586V19h1.414l9.314-9.314zm1.414-1.414l1.414-1.414-1.414-1.414-1.414 1.414 1.414 1.414zM7.242 21H3v-4.243L16.435 3.322a1 1 0 0 1 1.414 0l2.829 2.829a1 1 0 0 1 0 1.414L7.243 21z"
                        />
                    </svg>
                </div>
            </div>
        </figure>
    </>
}

export default ThumbnailPicker;